import PropTypes from "prop-types";
import { APIProvider } from "@vis.gl/react-google-maps";

const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

/**
 * Loads the Maps JavaScript API for the Places hooks. Only the first
 * APIProvider on the page loads the script, and vis.gl expects every provider
 * to take the same props, so this one passes only the key, as the map pages
 * do. The places library is imported on demand by `useMapsLibrary`.
 */
const PlacesProvider = ({ children }) => (
  <APIProvider apiKey={GOOGLE_API_KEY}>{children}</APIProvider>
);

PlacesProvider.propTypes = { children: PropTypes.node };

export default PlacesProvider;
